var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.233 65.811c-3.08 0-5.977-1.2-8.156-3.376L41.3 50.657c-.827-.829-2.268-.826-3.094 0l-11.82 11.82a11.463 11.463 0 01-8.156 3.377h-2.321L30.825 80.77c4.658 4.658 12.21 4.658 16.869 0l14.958-14.96zM18.23 24.155c3.08 0 5.977 1.199 8.156 3.376l11.82 11.822a2.19 2.19 0 003.094 0l11.777-11.779a11.463 11.463 0 018.156-3.376h1.419L47.694 9.239c-4.659-4.658-12.211-4.658-16.87 0L15.91 24.155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.024 36.57l-9.039-9.04c-.199.08-.414.13-.642.13h-4.11a8.123 8.123 0 00-5.706 2.365L43.751 41.8a5.637 5.637 0 01-3.997 1.654 5.637 5.637 0 01-3.997-1.653l-11.821-11.82a8.121 8.121 0 00-5.706-2.365h-5.054c-.215 0-.417-.05-.607-.122L3.494 36.57c-4.659 4.658-4.659 12.21 0 16.87l9.075 9.074c.19-.072.392-.122.607-.122h5.054a8.122 8.122 0 005.706-2.364l11.82-11.82c2.136-2.135 5.86-2.136 7.995 0l11.776 11.776a8.123 8.123 0 005.706 2.365h4.11c.228 0 .443.05.642.13l9.04-9.04c4.658-4.658 4.658-12.21 0-16.87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.753da9a0.svg";
export { ForwardRef as ReactComponent };